import RelatedArticleswithCategoryBlock from './RelatedArticleswithCategoryBlock'
import RelatedArticlewithCategoryCardBlock from './RelatedArticlewithCategoryCardBlock'

export { RelatedArticleswithCategoryBlock, RelatedArticlewithCategoryCardBlock }
